// AppUpdatePrompt removed — web only
export default function AppUpdatePrompt() { return null; }